import { render, staticRenderFns } from "./LoginBtnWithRules.vue?vue&type=template&id=d5246a62&scoped=true"
import script from "./LoginBtnWithRules.vue?vue&type=script&lang=ts"
export * from "./LoginBtnWithRules.vue?vue&type=script&lang=ts"
import style0 from "./LoginBtnWithRules.vue?vue&type=style&index=0&id=d5246a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5246a62",
  null
  
)

export default component.exports